import React from 'react';
import './TextureButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';
import Images from 'constants/Images';
import * as THREE from 'three';
import { Material } from 'three';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader } from "@react-three/fiber";

function TextureButton(props) {

    function handleClick() {
        if(SystemConfiguration.material != null){
            if(!Array.isArray(SystemConfiguration.material)){
                if(SystemConfiguration.textureEnabled) {
                    disableTexture(SystemConfiguration.material)
                } else {
                    enableTexture(SystemConfiguration.material, SystemConfiguration.mtl_file)
                }
            } else {
                // console.log(SystemConfiguration.material)
                for(var i = 0; i < SystemConfiguration.material.length; i++){
                    
                    if(SystemConfiguration.textureEnabled) {
                        disableTexture(SystemConfiguration.material[i])
                    } else {
                        enableTexture(SystemConfiguration.material[i], SystemConfiguration.mtl_file)
                    }
                }
            }

            SystemConfiguration.textureEnabled = !SystemConfiguration.textureEnabled
            console.log(SystemConfiguration.textureEnabled)
        }
    }

    function disableTexture(material) {
        material.color = {r: 0.1, g: 0.1, b: 0.1}
        //material.map.dispose()
        material.map = material.map_null//new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png");//SystemConfiguration.template_texture
        //material.map.needsUpdate = true
        material.map.needsUpdate = true
    }

    function enableTexture(material, mtl_file) {
        material.map = material.map_temp
        // material.map.encoding = 3001 // after retexturing this value is set to 3000 which makes the texture too bright
        material.color = {r: 1.0, g: 1.0, b: 1.0}
        material.map.needsUpdate = true
    }


    return (
        <img id="texturebutton" src={process.env.PUBLIC_URL + Images.button_texture} onClick={() => handleClick()}/>
    );

}

export default TextureButton;